/**
 * Dictation language helpers. In Agent Mode the agent sends its dictation
 * language (setDictationLanguage); the editor mic, AI Edit and the AI Edit
 * button's side follow it. In normal CRE the side follows the user's choice.
 */

/** Hebrew / Arabic dictation (any region) → right-to-left. */
export function isRtlDictationLanguage(code) {
  return /^(he|ar)(-|$)/i.test(String(code || ""));
}

/**
 * Side of the floating AI Edit button: Hebrew / Arabic → left, where it does
 * not cover the start of the lines; otherwise right (unchanged). Same rule in
 * Agent Mode and normal CRE.
 * Follows the report language (navbar switcher) as well as the dictation
 * language (Jacky, 3 Nov): a Hebrew report with the dictation language left
 * at its English default also puts it on the left.
 */
export function aiEditButtonSide({ dictationLanguage, reportLanguage } = {}) {
  return isRtlDictationLanguage(dictationLanguage) || isRtlDictationLanguage(reportLanguage)
    ? "left"
    : "right";
}
